import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { IAccountingAccounts } from 'src/app/@interfaces/accountingAccounts.interface';
import { ReportsService } from 'src/app/@pages/reports/reports.service';
import { takeUntil } from 'rxjs/operators';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { DialogComponent } from '../../dialog.component';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@Component({
  selector: 'app-crud-accounting-accounts',
  templateUrl: './crud-accounting-accounts.component.html',
  styleUrls: ['./crud-accounting-accounts.component.css'],
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    TranslatePipe,
  ],
})
export class CrudAccountingAccountsComponent implements OnInit {
  accountsList: IAccountingAccounts[] = [];
  unsubscribe$ = new Subject();

  constructor(
    private reportsService: ReportsService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.reportsService
      .getAllAccountingAccount()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        this.accountsList = result;
      });
  }

  update(id_account: number) {
    this.dialog
      .open(DialogComponent, {
        data: { id_account: id_account },
        disableClose: true,
      })
      .afterClosed()
      .subscribe((res) => {
        this.dialog.open(DialogComponent, {
          data: { accountingAccounts: true },
        });
      });
  }
}
